/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * All permissions in Breeze.
 * Must be in snake_case, as jstree uses the html id field to store the permission name.
 */
export enum Permission {
    ACCOUNT = 'account',
    ACCOUNT_EXPORT = 'account_export',
    ACCOUNT_LOG = 'account_log',
    ACCOUNT_PAYMENT_SETTINGS = 'account_payment_settings',
    ACCOUNT_RESTORE = 'account_restore',
    ACCOUNT_SETTINGS = 'account_settings',
    AUTOMATIONS = 'automations',
    BULK = 'bulk',
    CALENDAR_ACCESS_TO = 'calendar_access_to',
    CALENDAR_ACCESS_RESTRICT = 'calendar_access_restrict',
    CALENDAR_ACCESS_ALL = 'calendar_access_all',
    CALENDAR_OPTIONS = 'calendar_options',
    CHECKIN = 'checkin',
    CHECKIN_ONLY_NEW_PEOPLE = 'checkin_only_new_people',
    CHECKIN_ONLY_EXISTING_PEOPLE = 'checkin_only_existing_people',
    CHECKIN_ONLY_UPDATE_THUMBNAILS = 'checkin_only_update_thumbnails',
    CHECKIN_ONLY_CALENDAR_ACCESS_ALL = 'checkin_only_calendar_access_all',
    CHECKIN_EXISTING_PEOPLE = 'checkin_existing_people',
    CHECKIN_GENERAL = 'checkin_general',
    CHECKIN_NEW_PEOPLE = 'checkin_new_people',
    CHECKIN_OPTIONS = 'checkin_options',
    CHECKIN_ONLY = 'checkin_only',
    CHECKIN_ONLY_CALENDAR_ACCESS_TO = 'checkin_only_calendar_access_to',
    CHECKIN_ONLY_CALENDAR_ACCESS_RESTRICT = 'checkin_only_calendar_access_restrict',
    CHECKIN_UPDATE_THUMBNAIL = 'checkin_update_thumbnail',
    CONTRIBUTIONS = 'contributions',
    CONTRIBUTIONS_ADD = 'contributions_add',
    CONTRIBUTIONS_DELETE = 'contributions_delete',
    CONTRIBUTIONS_EDIT = 'contributions_edit',
    CONTRIBUTIONS_ONLINE_GIVING = 'contributions_online_giving',
    CONTRIBUTIONS_PEOPLE = 'contributions_people',
    CONTRIBUTIONS_PEOPLE_ENVELOPES = 'contributions_people_envelopes',
    CONTRIBUTIONS_PEOPLE_REPORTS = 'contributions_people_reports',
    CONTRIBUTIONS_PLEDGES = 'contributions_pledges',
    CONTRIBUTIONS_PLEDGES_ADD = 'contributions_pledges_add',
    CONTRIBUTIONS_PLEDGES_DELETE = 'contributions_pledges_delete',
    CONTRIBUTIONS_PLEDGES_EDIT = 'contributions_pledges_edit',
    CONTRIBUTIONS_REPORTS = 'contributions_reports',
    SETTINGS_PASSWORD = 'settings_password',
    DESCRIPTION = 'description',
    EVENTS = 'events',
    EVENTS_ADD = 'events_add',
    EVENTS_DELETE = 'events_delete',
    EVENTS_MODIFY = 'events_modify',
    EVENTS_REPORT = 'events_report',
    EVENTS_VIEW = 'events_view',
    EVENTS_VOLUNTEERS = 'events_volunteers',
    EXTENSIONS_API = 'extensions_api',
    EXTENSIONS_PCO = 'extensions_pco',
    EXTENSIONS_MAILCHIMP = 'extensions_mailchimp',
    EXTENSIONS_QUICKBOOKS = 'extensions_quickbooks',
    EXTENSIONS_SITES = 'extensions_sites',
    EXTENSIONS_CHURCH_APPS = 'extensions_church_apps',
    TITHELY_GIVING = 'tithely_giving',
    FAMILY = 'family',
    FOLLOWUPS = 'followups',
    FOLLOWUPS_ASSIGN = 'followups_assign',
    FOLLOWUPS_COMPLETE_OTHERS = 'followups_complete_others',
    FOLLOWUPS_DELETE = 'followups_delete',
    FOLLOWUPS_EDIT = 'followups_edit',
    FOLLOWUPS_OPTIONS = 'followups_options',
    FOLLOWUPS_VIEW_BY_ME = 'followups_view_by_me',
    FOLLOWUPS_VIEW_ME = 'followups_view_me',
    FOLLOWUPS_VIEW_OTHERS = 'followups_view_others',
    FORMS = 'forms',
    FORMS_ACCESS_ALL = 'forms_access_all',
    FORMS_ACCESS_TO = 'forms_access_to',
    FORMS_ACCESS_RESTRICT = 'forms_access_restrict',
    FORMS_CREATE_FORMS = 'forms_create_forms',
    FORMS_DELETE_ENTRIES = 'forms_delete_entries',
    FORMS_DELETE_FORMS = 'forms_delete_forms',
    FORMS_EDIT_ENTRIES = 'forms_edit_entries',
    FORMS_EDIT_FORMS = 'forms_edit_forms',
    FORMS_VIEW_ENTRIES = 'forms_view_entries',
    FORM_FOLDER_OPTIONS = 'form_folder_options',
    GROUPS = 'groups',
    GROUPS_CREATE = 'groups_create',
    GROUPS_EDIT = 'groups_edit',
    GROUPS_DELETE = 'groups_delete',
    GROUPS_LEADER = 'groups_leader',
    HISTORY = 'history',
    _USER_LOGGED_IN = '_user_logged_in',
    LOGOUT_AUTOMATICALLY_BROWSER = 'logout_automatically_browser',
    LOGOUT_AUTOMATICALLY_30_MINUTES = 'logout_automatically_30_minutes',
    LOGOUT_AUTOMATICALLY_4_HOURS = 'logout_automatically_4_hours',
    LOGOUT_AUTOMATICALLY_24_HOURS = 'logout_automatically_24_hours',
    LOGOUT_AUTOMATICALLY_1_WEEK = 'logout_automatically_1_week',
    LINKED_PEOPLE = 'linked_people',
    LINKED_PEOPLE_ATTENDANCE = 'linked_people_attendance',
    LINKED_PEOPLE_CONTRIBUTIONS = 'linked_people_contributions',
    LINKED_PEOPLE_FAMILY = 'linked_people_family',
    LINKED_PEOPLE_FORMS = 'linked_people_forms',
    LINKED_PEOPLE_GIVE = 'linked_people_give',
    LINKED_PEOPLE_GROUPS = 'linked_people_groups',
    LINKED_PEOPLE_PLEDGES = 'linked_people_pledges',
    LINKED_PEOPLE_TAGS = 'linked_people_tags',
    LINKED_PEOPLE_VOLUNTEER = 'linked_people_volunteer',
    LINKED_PERSON_EDIT_PICTURE = 'linked_person_edit_picture',
    LOGOUT_AUTOMATICALLY = 'logout_automatically',
    LOGOUT_TIME = 'logout_time',
    MARKETPLACE = 'marketplace',
    NAME = 'name',
    LINKED_PERSON_READ = 'linked_person_read',
    LINKED_PERSON_EDIT = 'linked_person_edit',
    PEOPLE = 'people',
    PEOPLE_ACTIONS_ASSIGN_TO_TAGS = 'people_actions_assign_to_tags',
    PEOPLE_ACTIONS_EMAIL = 'people_actions_email',
    PEOPLE_ACTIONS_EXPORT = 'people_actions_export',
    PEOPLE_ACTIONS_REMOVE_FROM_TAGS = 'people_actions_remove_from_tags',
    PEOPLE_ACTIONS_TEXT = 'people_actions_text',
    PEOPLE_ACTIONS_UPDATE_PEOPLE = 'people_actions_update_people',
    PEOPLE_ADD = 'people_add',
    PEOPLE_ARCHIVE = 'people_archive',
    PEOPLE_DELETE = 'people_delete',
    PEOPLE_LIMIT_EVERYONE = 'people_limit_everyone',
    PEOPLE_LIMIT_TAG_INCLUDE = 'people_limit_tag_include',
    PEOPLE_LIMIT_TAG_EXCLUDE = 'people_limit_tag_exclude',
    PERSON_READ = 'person_read',
    PERSON_EDIT = 'person_edit',
    PEOPLE_READ_ARCHIVE = 'people_read_archive',
    PERSON_EDIT_PICTURE = 'person_edit_picture',
    PERSON_EDIT_PRIVATE_DATA = 'person_edit_private_data',
    PERSON_READ_PRIVATE_DATA = 'person_read_private_data',
    PERSON_NOTES = 'person_notes',
    PERSON_READ_NOTES = 'person_read_notes',
    PERSON_EDIT_NOTES = 'person_edit_notes',
    PLEDGES = 'pledges',
    PROFILE = 'profile',
    ROLE_ID = 'role_id',
    SERVICE_PLAN_READ = 'service_plan_read',
    SERVICE_PLAN_WRITE = 'service_plan_write',
    SHOW_GIVE_TAB = 'show_give_tab',
    SHOW_MY_PROFILE = 'show_my_profile',
    SONG_LIBRARY_READ = 'song_library_read',
    SONG_LIBRARY_WRITE = 'song_library_write',
    TAGS = 'tags',
    TAGS_ACCESS_ALL = 'tags_access_all',
    TAGS_ACCESS_TO = 'tags_access_to',
    TAGS_ACCESS_RESTRICT = 'tags_access_restrict',
    TAGS_FOLDER_ACCESS_TO = 'tags_folder_access_to',
    TAGS_FOLDER_ACCESS_RESTRICT = 'tags_folder_access_restrict',
    TAGS_ASSIGN_UNASSIGN = 'tags_assign_unassign',
    TAGS_CREATE_FOLDERS = 'tags_create_folders',
    TAGS_CREATE_TAGS = 'tags_create_tags',
    TAGS_VIEW = 'tags_view',
    TAG_OPTIONS = 'tag_options',
    USERS = 'users',
}
